import * as React from 'react';
import { Avatar, Popover, Row } from 'antd';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { FC, useMemo, useState } from 'react';
import { SupplierFacilityCard } from './SupplierFacilityCard';
import { getProtectedImageUriForBuyer } from '../../../utils/FileAccessUtils';
import { nullSafeGet } from '../../../utils/DataAccessUtils';
import { AddressDisplay } from '../../address_display/AddressDisplay';
import { BuyerCompanyCard } from './buyerCompanyCard';

interface BuyerFacilityNameProps {
	company: any;
	mode?: 'card' | 'inline' | 'container' | 'avatar';
	secondaryField?: string;
	size?: 'default' | 'large';
	allowHover?: boolean;
	popoverMode?: 'simple' | 'full';
	placement?: string;
}

export const BuyerCompanyName: FC<BuyerFacilityNameProps> = ({
	company,
	mode = 'card',
	secondaryField = 'email',
	size = 'default',
	allowHover = true,
	popoverMode = 'full',
	placement = 'leftTop',
}) => {
	const onClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};
	const displayName = nullSafeGet('displayName', company);

	const popoverContent = (
		<BuyerCompanyCard
			company={company}
			name={displayName}
			subTitle={
				<AddressDisplay
					hidePostcode={true}
					hideCountry={true}
					hideStreetAddress={true}
					address={nullSafeGet('primaryAddress', company)}
					style={{ color: 'rgba(0,0,0,0.45)' }}
				/>
			}
			size={size}
			mode={popoverMode}
		/>
	);
	const element =
		mode === 'card' ? (
			<span>
				<BuyerCompanyCard
					company={company}
					name={displayName}
					subTitle={''}
					size={size}
					mode={popoverMode}
				/>
			</span>
		) : mode === 'inline' ? (
			<span>{nullSafeGet('name', company)}</span>
		) : mode === 'container' ? (
			<Ellipsis tooltip={false} fullWidthRecognition={true}>
				{nullSafeGet('name', company)}
			</Ellipsis>
		) : mode === 'avatar' ? (
			<span>
				<BuyerCompanyCard
					company={company}
					name={displayName}
					subTitle={''}
					size={size}
					mode={popoverMode}
				/>
			</span>
		) : (
			<span></span>
		);

	return allowHover ? (
		<Popover placement={placement} content={popoverContent}>
			{element}
		</Popover>
	) : (
		element
	);
};
